import React from 'react';
import { cloneDeep } from 'lodash';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Button, Form, FormSection, Dropdown } from '@praktio/common-ui';

import DragDropItem from '../../common/DragDropItem';
import { None } from '../../../utils/constants';

export const CourseModules = ({
  course,
  setCourse,
}: {
  course: ICourse;
  setCourse: React.Dispatch<React.SetStateAction<ICourse>>;
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const modules = course.modules || [];
  const moveModule = (dragId: string, hoverId: string, dragUp: boolean) => {
    if (dragId && hoverId) {
      const updatedCourse = cloneDeep(course);
      const dragIndex = updatedCourse.modules.findIndex((m) => m._id === dragId);
      if (dragIndex > -1) {
        const module = updatedCourse.modules[dragIndex];
        updatedCourse.modules.splice(dragIndex, 1);
        const hoverIndex = updatedCourse.modules.findIndex((m) => m._id === hoverId);
        if (hoverIndex > -1) {
          if (dragUp) {
            updatedCourse.modules.splice(hoverIndex, 0, module);
          } else {
            updatedCourse.modules.splice(hoverIndex + 1, 0, module);
          }
          setCourse(updatedCourse);
        }
      }
    }
  };

  const selectOptions =
    course.categories?.map((c) => ({ label: c.name, id: c._id as string })) || [];
  if (selectOptions.length > 0) {
    selectOptions.unshift({ id: None, label: 'None' });
  }

  const onCategoryChange = (value: string, id: string) => {
    const updatedCourse = cloneDeep(course);
    const module = updatedCourse.modules.find((m) => m._id === id);
    if (module) {
      module.categoryId = value === None ? undefined : value;
      setCourse(updatedCourse);
    }
  };

  return (
    <Form formId="course-modules-form" onSubmit={() => {}} className="mt-4">
      <FormSection sectionName="Course Modules">
        <div>
          <Button onClick={() => navigate(`${location.pathname}/modules/new`)}>Add Module</Button>
        </div>
        <div className="Course-modules">
          <div className="Course-modules-header">
            <div className="move-grab"></div>
            <div className="title">Module</div>
            <div className="time-release">Time Release (in days)</div>
            <div className="category">Category</div>
          </div>
          <div>
            {modules
              .filter((m) => m)
              .map((m, i) => (
                <DragDropItem key={m._id} id={m._id as string} index={i} moveItem={moveModule}>
                  <div className="Course-modules-row">
                    <span className="material-icons move-grab">open_with</span>
                    <Link className="title" to={`${location.pathname}/modules/${m._id}`}>
                      {m.title}
                    </Link>
                    <div className="time-release">{m.timeReleasePeriod}</div>
                    <div className="category">
                      {selectOptions.length > 0 && (
                        <Dropdown
                          id="category-dropdown"
                          options={selectOptions}
                          value={selectOptions.find((o) => o.id === (m.categoryId || None))}
                          onSelect={(id) => onCategoryChange(id as string, m._id as string)}
                        />
                      )}
                    </div>
                  </div>
                </DragDropItem>
              ))}
          </div>
        </div>
      </FormSection>
    </Form>
  );
};

export default CourseModules;
